import { render, staticRenderFns } from "./UserTypographyResetAllChangesModal.vue?vue&type=template&id=c7b572ee&"
import script from "./UserTypographyResetAllChangesModal.vue?vue&type=script&lang=js&"
export * from "./UserTypographyResetAllChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports